<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill="currentcolor" d="M16 4 6 14l1.41 1.41L15 7.83V28h2V7.83l7.59 7.58L26 14 16 4z"/></svg>